import Report from "report";
import TableReportHelper from "report/helper";
import { gerar as gerarTemplateEtiqueta } from "OkReport/template/TemplateEtiqueta";
import EtiquetaInscricaoReport from "./EtiquetaInscricaoReport";
import _ from 'lodash'

export default class EtiquetasInscricaoReport extends Report {
    constructor(obj) {
        super();
        //9x3cm
        this.obj = obj;


        let sortList = obj.lista.slice();
        sortList = sortList.sort((A, B) => {
            let nomeA = _.get(A, "empresa.funcionarios.nomeCracha") || _.get(A, "empresa.funcionarios.nomeParticipante") || "";
            let nomeB = _.get(B, "empresa.funcionarios.nomeCracha") || _.get(B, "empresa.funcionarios.nomeParticipante") || "";     
            return nomeA.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
                .localeCompare(
                    nomeB.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
                );
        });
        this.lista = sortList;
    }

    get title() {
        return "Etiqueta";
    }

    get template() {
        return { gerar: gerarTemplateEtiqueta };
    }

    get fileName() {
        return this.title;
    }

    async render() {

        this.helper = new TableReportHelper(this.lista);
        let content = []

        this.lista.forEach(et => {
            if (content.length) {
                content.push(this.helper.pageBreak())
            }
            content.push(EtiquetaInscricaoReport.renderEtiqueta(et))
        });


        return content
    }

}
